<template>
  <div>
    <div class="cropper-wrapper">
      <cropper
        v-if="image.url"
        ref="cropper"
        class="cropper"
        :src="image.url"
        :debounce="false"
        :stencil-size="stencilSize"
        :default-size="defaultSize"
        :stencil-props="{
          handlers: {},
          movable: false,
          resizable: false,
          aspectRatio: 16 / 9,
        }"
        image-restriction="stencil"
        @change="onChangeCropper"
        :transitions="false"
      />
      <div v-else class="cropper no-image-icon">
        <img :src="NoImgaeIcon" class="w-20" />
      </div>
      <div class="image-condition mt-1" v-if="!image.url">
        *File formats: JPG, JPEG, PNG <br />
        *File size: Up to 2 MB <br />
        *Ratio: 16:9
      </div>
      <!-- <navigation-zoom /> -->
      <div class="slider-zoom" v-if="image.url">
        <vue-slider
          :min="0"
          :max="1"
          :interval="0.01"
          :tooltip="'none'"
          v-model="cropperData.value"
          @change="onZoomImg"
        ></vue-slider>
      </div>
      <div v-if="image.url" class="icon-delele-image" @click="handleDelete">
        X
      </div>
    </div>
    <div class="button-wrapper d-flex justify-content-center mt-2 mb-2">
      <cancel-button class="mr-1" @click.native="$emit('onCloseModal')" />
      <button class="cropper-upload-button" @click="onUpload" v-if="!image.url">
        <input
          type="file"
          ref="file"
          class="d-none"
          @change="handleUploadImage($event)"
          :accept="acceptFile.toString()"
        />
        <div class="d-flex align-items-center">
          <upload-icon class="mr-2" />
          <span>Upload Image</span>
        </div>
      </button>
      <save-button
        v-if="image.url"
        class="ml-1"
        @click.native="onCropImage"
        :btnLabel="'Apply'"
      />
    </div>
  </div>
</template>

<script>
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
import {
  reactive,
  getCurrentInstance,
  watch,
  computed,
  onBeforeMount,
  ref,
} from "@vue/composition-api";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";
import NoImgaeIcon from "@/assets/images/icons/img.svg";
import UploadIcon from "@/@core/components/svg/button/Upload.vue";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";

export default {
  components: {
    Cropper,
    UploadIcon,
    VueSlider,
  },

  props: {
    imageUrl: [Object, String],
    acceptFile: {
      type: [String, Array],
      default: () => [".jpg", ".jpeg", ".png"],
    },
  },
  setup(props) {
    const vm = getCurrentInstance().proxy;

    const { openErrorModal } = useValidationModal();

    const image = reactive({
      file: null,
      url: props.imageUrl || null,
      type: null,
    });

    const onCropImage = () => {
      const { canvas } = vm.$refs.cropper.getResult();
      image.url = canvas.toDataURL();
      const file = dataURLtoFile(image.url);
      image.file = file;
      vm.$emit("onCropImage", image);
    };

    //convert base64 to file
    const dataURLtoFile = (dataurl, filename = "abc") => {
      var arr = dataurl.split(",");
      var mime = arr[0].match(/:(.*?);/)[1];
      var bstr = atob(arr[1]);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    };

    const handleUploadImage = (event) => {
      const filesOBJ = event.target.files[0];

      try {
        const size = (filesOBJ.size / 1024 / 1024).toFixed(2);

        if (filesOBJ.name.length > 0) {
          var isValidExtension = false;
          var fileExtension = null;

          const _validFileExtensions = props.acceptFile;

          for (var i = 0; i < _validFileExtensions.length; i++) {
            var curExtension = _validFileExtensions[i];
            fileExtension = filesOBJ.name
              .substr(
                filesOBJ.name.length - curExtension.length,
                curExtension.length
              )
              .toLowerCase();

            if (fileExtension == curExtension.toLowerCase()) {
              isValidExtension = true;
              if (size <= 2) {
                const newImageUrl = URL.createObjectURL(filesOBJ);
                image.file = filesOBJ;
                image.url = newImageUrl;
              } else {
                openErrorModal(
                  "ไฟล์รูปภาพมีขนาดเกิน 2 MB",
                  "<span>ขนาดไฟล์ที่อัปโหลด </span> " +
                    size +
                    "<span> MB</span>" +
                    "<div>กรุณาอัปโหลดไฟล์ใหม่อีกครั้ง</div>",
                  "ปิด"
                );
              }
              break;
            }
          }

          if (!isValidExtension) {
            openErrorModal(
              "อัปโหลดไฟล์รูปภาพไม่ถูกต้อง",
              "<div>กรุณาอัปโหลดใหม่อีกครั้ง</div>" +
                "<div class='text-bold'>นามสกุลไฟล์ที่รองรับ " +
                _validFileExtensions.join(", ") +
                "</div>",
              "ปิด"
            );
            return (image.file = null);
          }
        }
      } catch (error) {}
    };

    const handleDelete = () => {
      image.file = null;
      image.url = null;
      // vm.$refs.file.value = null;
    };

    const onUpload = () => {
      vm.$refs.file.click();
    };

    const defaultSize = ({ imageSize }) => {
      return {
        width: imageSize.width,
        height: imageSize.height,
      };
    };

    const stencilSize = () => {
      return {
        width: 682,
        height: 384,
      };
    };

    const cropperData = reactive({
      zoom: 0,
      value: 0,
    });

    //chagne image zoom
    const onChangeCropper = () => {
      const cropper = vm.$refs.cropper;
      if (cropper) {
        const { coordinates, imageSize } = cropper;
        if (
          imageSize.width / imageSize.height >
          coordinates.width / coordinates.height
        ) {
          cropperData.zoom =
            (cropper.imageSize.height - cropper.coordinates.height) /
            (cropper.imageSize.height - cropper.sizeRestrictions.minHeight);
        } else {
          cropperData.zoom =
            (cropper.imageSize.width - cropper.coordinates.width) /
            (cropper.imageSize.width - cropper.sizeRestrictions.minWidth);
        }
        cropperData.value = cropperData.zoom;
      }
    };

    //change image zoom with navigation zoom
    const onZoomImg = (newValue) => {
      const cropper = vm.$refs.cropper;
      if (cropper) {
        if (cropper.imageSize.height < cropper.imageSize.width) {
          const minHeight = cropper.sizeRestrictions.minHeight;
          const imageHeight = cropper.imageSize.height;
          cropper.zoom(
            (imageHeight - cropperData.zoom * (imageHeight - minHeight)) /
              (imageHeight - newValue * (imageHeight - minHeight))
          );
        } else {
          const minWidth = cropper.sizeRestrictions.minWidth;
          const imageWidth = cropper.imageSize.width;
          cropper.zoom(
            (imageWidth - cropperData.zoom * (imageWidth - minWidth)) /
              (imageWidth - newValue * (imageWidth - minWidth))
          );
        }
      }
    };

    watch(
      () => props.imageUrl,
      () => {
        image.url = props.imageUrl;
      },
      { deep: true }
    );

    return {
      image,
      onCropImage,
      onUpload,
      handleUploadImage,
      handleDelete,
      NoImgaeIcon,
      cropperData,
      defaultSize,
      stencilSize,
      onZoomImg,
      onChangeCropper,
    };
  },
};
</script>

<style>
.cropper {
  height: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.vue-advanced-cropper__background {
  background: #fff;
}

.cropper-wrapper {
  margin-top: 20px;
  margin-bottom: 20px;
  user-select: none;
  position: relative;
}

.btn-crop {
  background-color: #37be69;
  border: 1px solid #37be69;
  width: 50px;
  height: 30px;
}

.icon-delele-image {
  position: absolute;
  width: 30px;
  height: 30px;
  background-color: #404040;
  right: 0;
  top: 15px;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 23px;
  cursor: pointer;
}

.no-image-icon {
  background-color: #f8f8f8;
  border: 2px dashed #e0e0e0;
}

.cropper-upload-button {
  padding: 0.5rem 0.8rem;
  border-radius: 0.8rem;
  font-size: 20px;
  background-color: var(--button-primary) !important;
  border: 1px solid var(--button-primary) !important;
}

.cropper-upload-button svg {
  width: 18px;
  fill: var(--button-primary-font);
}

.slider-zoom {
  width: 100%;
  padding: 20px 120px 10px;
}

.vue-slider-process {
  background-color: #dddddd;
}

.vue-slider-rail {
  background-color: #9e9e9e;
}

.vue-slider-dot-handle {
  background-color: #dddddd;
  box-shadow: none;
}

.vue-slider-dot-handle-focus {
  box-shadow: rgb(101 119 134 / 20%) 0px 0px 7px,
    rgb(101 119 134 / 15%) 0px 1px 3px 1px;
}

.vue-slider-dot-handle:active {
  transform: scale(1.2);
}

.image-condition {
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: red;
}
</style>